<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <div>
                <h1 class="page-header mb-0"><i class="fas fa-helmet-safety"></i> Munkakörök</h1>
            </div>
            <div class="ms-auto" v-if="user && user.role_id == 1">
                <button class="btn btn-success btn-rounded px-4 rounded-pill" @click="openModal()"><i
                        class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új Munkakör</button>
            </div>
        </div>
        <panel title="Munkakör lista">
            <Loading v-if="workjobs === false"></Loading>
            <NoRecords v-else-if="workjobs.length == 0" main_icon="fa fa-helmet-safety" title="Nincsenek munkakörök">
            </NoRecords>
            <div class="table-responsive" v-else>
                <table class="table table-striped">
                    <thead class="table-dark">
                        <tr>
                            <th></th>
                            <th>Megnevezés</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(workjob, id) in workjobs" :key="id">
                            <td width="10%">
                                <template v-if="user.role_id == 1">
                                    
                                    <button class="btn btn-xs btn-warning" title="szerkesztés" @click="openModal(workjob)"><i
                                    class="fa fa-pencil"></i></button>
                                    <button class="btn btn-xs btn-danger ms-1" title="törlés" v-if="workjob.user_count == 0"><i
                                        class="fa fa-trash"></i></button>
                                </template>
                            </td>
                            <td>{{ workjob.name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </panel>
        <b-modal id="workjobModal" @ok="modalHandler">
            <template slot="modal-header">
                <h4 class="modal-title">Munkakör {{ workjob.id == null ? 'létrehozása' : 'szerkesztése' }}</h4>
                <a class="btn-close" @click="closeAddModal()"></a>
            </template>
            <Loading :title="workjob.id ? 'Frissítés' : 'Létrehozás'" v-if="loading"></Loading>
            <div v-else>
                <label class="form-label">Név:</label>
                <input type="text" class="form-control" v-model="workjob.name">
                <div class="invalid-feedback d-block" v-if="errors.name">
                    {{ errors.name[0] }}
                </div>
            </div>
            <template #modal-footer="{ cancel, ok }">
                <b-button variant="default" @click="cancel()">
                    Mégse
                </b-button>
                <b-button variant="primary" @click="ok()">Mentés</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Loading from '../../components/Loading';
import NoRecords from '../../components/NoRecords';
import Workjob from '../../apis/Workjob';
export default {
    components: {
        Loading, NoRecords
    },
    data() {
        return {
            workjobs: false,
            workjob: {
                name: null,
            },
            loading: false,
            errors: []
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        Workjob.index().then(response => {
            this.workjobs = response.data;
        })
    },
    methods: {
        openModal(workjob) {
            if(workjob){
                this.workjob = Object.assign({}, workjob);
            }
            this.$bvModal.show('workjobModal');
        },
        modalHandler(bvModalEvt){
            bvModalEvt.preventDefault();
            if(this.workjob.id){
                this.updateWorkjob();
            }else{
                this.sendWorkjob();
            }
        },
        sendWorkjob() {
            this.loading = true;
            Workjob.store(this.workjob).then(response => {
                this.closeModal();
                this.workjobs.push(response.data);
            }).catch(error => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
            }).finally(() => {
                this.$set(this, 'loading', false);
            });
        },
        updateWorkjob() {
            this.loading = true;
            Workjob.update(this.workjob.id, this.workjob).then(response => {
                this.closeModal();
                this.workjobs[this.workjobs.findIndex(w => w.id == response.data.id)] = response.data;
            }).catch(error => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
            }).finally(() => {
                this.$set(this, 'loading', false);
            });
        },
        closeModal() {
            this.$bvModal.hide('workjobModal');
            this.resetWorkjob();
        },
        resetWorkjob() {
            this.workjob = {
                name: null,
            };
        }
    }
}
</script>